import React, { FunctionComponent } from 'react';
import { TextBox } from '../../atoms/textBox';
import { PreferenceConditionCategory } from '../../../types/personShow';

type Props = {
  categories: PreferenceConditionCategory[];
  selectedConditions: string[];
  filterText: string;
  onChangeFilter: (value: string) => void;
  onClick: (name: string) => void;
  onScrollTo: (categoryId: number) => void;
};

const SelectedCheck = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="0 0 14 10" fill="none" aria-hidden="true">
    <path
      d="M4.88542 9.89714L0.21875 5.23047L1.11458 4.33464L4.88542 8.10547L12.8854 0.105469L13.7812 1.0013L4.88542 9.89714Z"
      fill="#19190F"
    />
  </svg>
);

export const Presentation: FunctionComponent<Props> = ({
  categories,
  selectedConditions,
  filterText,
  onChangeFilter,
  onClick,
  onScrollTo,
}) => {
  const isSelected = (name: string) => selectedConditions.includes(name);

  return (
    <div className="person__show__modal__inner preferenceConditionsModal">
      <p className="person__show__modal__inner--title">
        企業や職場、選考について希望する条件を選択して保存してください
        <span className="subtitle">※複数選択可能</span>
      </p>

      <div className="preferenceConditionsModal__sticky">
        <TextBox
          type="search"
          name="preferenceConditionsFilter"
          value={filterText}
          className="preferenceConditionsModal__filter"
          placeholder="絞り込む"
          onChanged={(_, value) => onChangeFilter(value)}
        />

        {categories.length > 0 && (
          <nav className="preferenceConditionsModal__categories" aria-label="こだわり条件のカテゴリ">
            <ul>
              {categories.map(category => (
                <li key={`preference_condition_category_link_${category.id}`}>
                  <button type="button" onClick={() => onScrollTo(category.id)}>
                    {category.name}
                  </button>
                </li>
              ))}
            </ul>
          </nav>
        )}
      </div>

      {categories.length > 0 ? (
        <div className="preferenceConditionsModal__list">
          {categories.map(category => (
            <section
              id={`preference_condition_category_${category.id}`}
              className="preferenceConditionsModal__category"
              key={`preference_condition_category_${category.id}`}
            >
              <h4>{category.name}</h4>
              <ul>
                {category.preferenceConditions.map(condition => (
                  <li key={condition.id}>
                    <button
                      type="button"
                      className={isSelected(condition.name) ? 'selected' : ''}
                      aria-pressed={isSelected(condition.name)}
                      onClick={() => onClick(condition.name)}
                    >
                      <span>{condition.name}</span>
                      {isSelected(condition.name) && <SelectedCheck />}
                    </button>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      ) : (
        <p className="preferenceConditionsModal__empty">
          該当するこだわり条件はありません
        </p>
      )}
    </div>
  );
};
